export const apiList = {
  //用户相关接口
  user: {
    getAuthToken: '/auth/oauth/token', //登录接口
    getTokenUser: '/auth/token/query-token', //根据token查询用户信息
    getSendSmsCode: '/admin/mobile/sendSmsCode/public/', //发送短信
    getSendEmailCode: '/admin/email/sendEmailCode/public/', //发送邮件
    getVeriSmsCode: '/admin/mobile/checkCode/', //验证手机验证码
    getVeriEmailCode: '/admin/email/checkCode/', //验证邮箱验证码
    getEditPassword: '/admin/user/findPwd', // 修改密码
    getAddRegister: '/admin/user/register/', // 手机号注册帐号
    getAccountInfo: '/admin/user/getById/', // 根据id获取帐号信息
    getEditPerson: '/admin/user/editPerson', // 个人信息完善
    getUpdateInfo: '/admin/user/updateUserInfo', // 修改帐号信息
    getSendSmsCodes: '/admin/mobile/sendSmsCode/', // 发送手机验证码-登录后的
    getUserCheckPwd: '/admin/user/checkPwd', // 验证帐号密码是否正确
    getCancleledReason: '/admin/user/getCancleledReason/', // 获取帐号能否注销和原因
    getCancleled: '/admin/user/cancleled/', // 注销个人帐号
    getRecallCancleled: '/admin/user/recallCancleled/', // 撤回注销个人帐号
    getSignOut: '/auth/token/logout', // 退出登录
    getInstitution: '/admin/institution/getInstitution/', // 根据三级域名获取机构信息
    getUserInfo: '/admin/user/getPersonalInformation/', // 根据id获取个人信息
    getUpdatePersonal: '/admin/user/updatePersonalInformation', // 修改个人信息
    getDictItem: '/dict/dictItem/getDictItem/', // 获取字典项   学段 period；学科 subject；学制 school_length；年级 grade；
    getCommonModeration: '/general/moderation/commonModeration', // 文本内容审核
    getVipHeader: '/vip/membershipHeader/', // 获取会员头像框
    unbindWechat: '/admin/social/unbind', // 解除绑定微信
    bindWechat: '/admin/social/bind', // 绑定微信
    setUserTheme: '/admin/user/setUserTheme', // 设置主题
    getManagerContacts: '/admin/member/getManagerContacts', // 获取机构/学校下管理员\
    getAvatarList: '/admin/user/getAvatarList', // 获取用户头像列表
    unbindMobile: '/admin/user/unitePhone', // 解除绑定手机
    getUserLastType: '/admin/member/getUserLastType/', // 获取用户身份列表
    changeUserType: '/admin/member/changeUserType/', // 切换用户身份
    getUserDecorationList: '/admin/user-decoration/getUserDecorationList', // 获取用户可用装饰列表（头像、头像框、挂饰）
    updateAvatar: '/admin/user-decoration/updateAvatar', // 更新装饰选中状态并更新合成头像
    updateTitle: '/admin/user-decoration/updateTitle', // 更新称号选中状态
  },
  menu: {
    getPlatformAppList: '/admin/app/project/query/user/institutionPlatform/baseInfo/', // 获取平台应用列表
    getAppSubmenu: '/admin/app/project/query/user/menus/', // 获取指定应用子菜单
    searchHelpCenter: '/general/help-center/search', // 搜索帮助中心
  },
  todo: {
    getSelect: '/teachingManage/generalAgent/homePageToBeHandled',
    closeNotification: '/teachingManage/generalAgent/pollingForBacklogClose',
    pollingForBacklog: '/teachingManage/generalAgent/pollingForBacklog',
    teacherHomeToDoList: '/teachingManage/generalAgent/teacherHomeToDoList',
  },
  home: {
    getAreaTree: '/admin/province/areaTree', // 获取省市区树
    getPlanData: '/teachingManage/generalAgent/homeToDoList/', // 目标和任务计划内的数据
    getSpaAfficheList: '/general/roto/getShowList/', // 广告列表
    getMsgNotifyTip: '/msgNotify/msgNotify/tip', // 跑马灯通知
    getMsgNotifyList: '/msgNotify/msgNotify/unReadList', // 消息列表
    getMstListAll: '/msgNotify/msgNotify/findAll', // 所以消息列表
    unReadCount: '/msgNotify/msgNotify/unReadCount', // 当前用户未读消息数量
    getAppMusts: '/admin/app/musts', // 必备应用
    getAppGroup: '/admin/app/listUserPlatformGroupByMemberType/', // 应用列表
    getAppAlias: '/admin/app/access/alias/', // 查看应用权限
    getGroupList: '/group/top/list/', // 群组列表
    getMyGroupList: '/group/myGroups/', // 我的群组
    getGroupQrCode: '/group/byCode/', // 根据群号查找群组
    getGroupAdd: '/group/member/join', // 加入指定群组
    getGroupAddList: '/group/member/added/list/', // 已加入的群组
    getGroupDel: '/group/member/quit/', // 退出指定群组
    getCourse: '/course/course/lib/get/random', // 随机获取一个学程
    getNoAccesses: '/admin/app/noAccesses', // 应用中心
    getAppInfo: '/admin/app/access/alias/', // 通过别名访问应用信息
    getBatchUpdate: '/msgNotify/msgNotify/batchUpdate', // 消息标记为已读
    deleteMsg: '/msgNotify/msgNotify/', // 删除消息
    batchDeleteMsg: '/msgNotify/msgNotify/batchDelete', // 批量删除消息
    getDefaultSchool: '/admin/address/getDefaultSchool', // 默认的学校
    getCurrentWeather: '/tpi/weather/currentWeather', // 获取当前天气
    getDeptInfo: '/admin/dept/deptList', // 获取部门信息
    getClassPhotos: '/photo/photo/getPhotoList', // 获取班级相册
    getAppList: '/admin/app/alias/all', // 获取所有的应用列表
    getAppBubbleByAlias: '/general/app/bubble/getAppBubbleByAlias', // 应用气泡数量获取
    getAppCategoryBubbleByCategories: '/general/app/bubble/getAppCategoryBubbleByCategories', // 应用菜单气泡数量获取
    getAppSort: '/admin/user/app/sort/', // 用户下分类应用排序获取
    getAppUsable: '/admin/app/timeControl/app/usable/', // 应用可用性检查
    getAllTimeRange: '/admin/app/timeControl/query/getAllTimeRange/', // 获取当前用户所有的禁用时间段
    getAppPage: '/admin/app/examine/approve/query/getAppPage', // 获取可申请应用相关数据/admin/appComponent

    getUnRead: '/general/genNotice/getUnRead', // 获取当前用户的发布的【更新通知】类型的未读消息
    readNotify: '/general/genNotice/readNotify/', // 已读【更新通知】
    notifyDel: '/general/genNotice/notifyDel/', // 【更新通知】详情
    readResource: '/resource/resource/pub/user/see/', // 已读素材
    getUserTypeSchoolList: '/admin/dept/getUserTypeSchoolList', // 获取用户学校列表
    getCurrentSemesterBySchoolId: '/arranging/semester/getCurrentSemesterBySchoolId', // 根据学校id获取当前学期
    getClassPeriodByUserId: '/admin/deptMember/getClassPeriodByUserId', // 根据用户获取班级的学段
    getLevelRankDetail: '/admin/level-rank/detail', // 获取用户等级和段位以及积分信息
    // 首页数据看板接口
    dateReport: {
      getSchoolList: '/admin/dataAuth/getAuthSchoolList', // 获取学校列表
      getClassTypes: '/dataReport/rector/dateReport/getClassTypes', // 获取班级类型
      getGrades: '/dataReport/rector/dateReport/getGrades', // 获取年级
      getDeptAuthList: '/admin/dataAuth/getDeptAuthList', // 获取年级或者学校 新
      getClass: '/dataReport/teacher/dateReport/getClass', // 获取班级
      // 校长
      rector: {
        getWeekStatic: '/dataReport/rector/dateReport/getWeekStatic', // 本周课堂
        getGradeClassroomWeekStatic: '/dataReport/rector/dateReport/gradeClassroomWeekStatic', // 本周课堂组织情况
      },
      // 年级主任
      director: {
        getWeekStatic: '/dataReport/director/dateReport/getWeekStatic', // 本周课堂
        getGradeClassroomWeekStatic: '/dataReport/director/dateReport/gradeClassroomWeekStatic', // 本周课堂组织情况
      },
      // 教师
      teacher: {
        getWeekStatic: '/dataReport/teacher/dateReport/getMonthStatic', // 本月课堂
        getGradeClassroomWeekStatic: '/dataReport/teacher/dateReport/submissionDataStatistics', // 本月课堂作品提交数据统计
      },
    },
    // 小组件相关
    getAppComponent: '/admin/appComponent', //获取应用组件列表
    getCommonAppList: '/admin/app/common', //常用应用列表
    subjectListByPerson: '/dict/dictItem/subjectListByPerson', // 获取学科列表（个人学科排序）
    updateSubjectSort: '/dict/dictItem/updateSubjectSort', // 更新学科排序
    studentCourseList: '/space/res/pub/student/list', // 获取学生课程列表
    activityList: '/activity/participant/', // 获取活动列表
    useApp: '/admin/app/use', //使用应用
    noteList: '/cloudNotes/note/',
    genLabelLib: '/general/genLabelLib/queryList', //获取标签
    readCourse: '/course/course/pub/user/read/', // 已读学程
    exerciseList: '/exercise/typicalExercises/page', //典型习题列表
    // 学生首页自主管理
    evaluate: {
      permissionCheck: 'evaluate/evaProjectPermissionCheck/prePermissionCheck', // 评价应用前置检查
      save: 'evaluate/evaProject/save', // 新建评价
      personals: 'evaluate/execute/personal/view', // 获取个人列表
      evaluateCount: 'evaluate/execute/evaluateCount/', // 获取指标被评价次数
      evaluateTree: '/evaluate/execute/evaluate/', // 获取指标tree
      evaluateSubmit: '/evaluate/execute/submit', // 提交验收
      queryComments: '/evaluate/execute/queryComments/', // 评语列表
      addComments: '/evaluate/execute/addComments', // 添加评语
      deleteComments: '/evaluate/execute/deleteComments/', // 删除评语
      evaUserInfo: 'evaluate/execute/userInfo', // 获取用户名称和头像等信息
    },
    getTimeTableDefaultShowClass: '/arranging/timetable/query/student/getDefaultShowClass', // 获取默认展示课表的班级
    getTimeTableDetail: '/arranging/timetable/query/student/theWeek/', // 获取课表详情
  },
  resources: {
    getCourseVersion: '/course/warehouse/getVersion/', // 获取学程新旧版本(用于获取新课程详情)
    getLibIdByResId: 'exercise/createCentre/exercisesPaper/getLibIdByResId/', // 根据resId获取libId(习练)
    getCurriculimDetailsById: '/curriculum/creatingCentre/create/detail/', // 【课程】根据id查询课程详情(新课程详情)
    getCourseDetail: '/course/course/lib/tree/', // 学程详情(旧)
    getCurriculumDetail: '/curriculum/curriculum/lib/get/', // 课程详情
    getCurriculumAboutList: '/curriculum/curriculum/lib/about/list', // 相关课程
    getNewCurriculumAboutList: '/curriculum/curriculum/lib/about/list', // 【课程】相关课程(新课程详情)
    getNewUseResource: '/resource/resource/cite/', // 引用资源(新课程详情)
    getNewUseCourse: '/course/warehouse/copyAndCite/', // 引用学程(新课程详情)
    getNewUseExercise: '/exercise/createCentre/exercisesPaper/referenceIn/', // 引用习练(新课程详情)
    getNewUseCurriculum: '/curriculum/curriculum/local/cite', // 【课程】引用课程(新课程详情)
    getExerciseDetail: '/exercise/exercisesLib/get/paper/lib/', // 习练详情
    getToolDetail: '/tpi/rzy/getToolDetail/', // 睿智云工具详情
    getToolUrl: '/tpi/rzy/getToolUrl', // 睿智云工具地址
    getResourceInfo: '/resource/resourceLib/get/', // 获取资源详情
    getPersonResourceInfo: '/resource/resource/get/', // 获取个人资源详情
    collectLesson: '/curriculum/curriculum/coll/', //课程收藏
    useLesson: '/curriculum/curriculum/local/cite/', //课程引用'
    getVipList: '/vip/strategy/forResource', // 获取会员策略
    getNotAuth: '/curriculum/curriculum/local/getNotAuthResource/', // 获取无权限资源列表
    getCourseAuth: '/course/newCourse/getRole/', // 获取学程访问权限
    checkCurriculumAuth: '/admin/selector/checkPeriodAndSubject', //校验用户是否学段和学科权限
  },
  topic: {
    getArticleDetail: '/general/features/', //查看专栏
  },
  activityNews: {
    getNewsDetail: '/activity/information/',
  },
  // 选题页
  choiseExercise: {
    getKnowledgeTree: '/dict/knowledge/tree', // 获取知识点树
    getCatalogTree: '/dict/tutorialDir/getDirByTutorial/', // 获取章节树
    getExerciseListByLibrary: '/exercise/platform/page', // 获取资源库习题列表
    getExerciseListByCenter: '/exercise/personal/creating/page/paper', // 获取创作中心习题列表
  },
  // 组卷页
  practicePaper: {
    addPractice: '/exercise/createCentre/exercisesPaper/add', // 新增习练
    getPracticeDetail: '/exercise/createCentre/exercisesPaper/selectByResId/', // 查询习练详情
    editPractice: '/exercise/createCentre/exercisesPaper/edit', // 编辑习练
    getResourceState: '/res/formContent/getResourceState', // 查询资源列表资源状态
    applyEditExercise: '/exercise/warehouse/', // 习练的习题申请修改
  },
  excersise: {
    getToolList: '/tpi/drawing/page', // 获取工具箱列表
    saveOrUpdateTool: '/tpi/drawing/saveOrUpdate', // 新增和修改工具
    getDictItem: '/dict/dictItem/getDictItem/', // 资源字典选择
    getTutorial: '/dict/tutorial/list', // 获取教材
    getDirByTutorial: '/dict/tutorialDir/getDirByTutorial/', // 获取单元
  },
  tpi: {
    flowIreader: '/tpi/reader/read', // 掌阅记录
    zujuan: '/tpi/xkw/ejt/zujuan/callback', // 学科网组卷
    syn_status: '/tpi/xkw/ejt/getPaper/syn/status', // 学科网轮询
  },
  boxiao: {
    getAuthSchoolList: '/admin/dataAuth/getAuthSchoolList', //获取当前用户有数据权限的学校列表
    saveCurrentSchool: '/admin/dept/saveCurrentSchool/', //保存用户当前学校信息
  },
  homepage: {
    teacherSpace: '/space/spaVisitorTeacher/getSpaceBaseInfo/', // 教师空间基础信息
    photos: '/space/spaVisitorTeacher/getAlbumPage', // 相册分页数据
    switch: '/space/spaVisitorTeacher/getAlbumLastOrAfter', // 相册上一页下一页
    teach: '/space/spaVisitorTeacher/getTeachingPage', // 教学数据分页
    create: '/space/spaVisitorTeacher/getCreatePage', // 创作数据分页
    events: '/space/spaVisitorTeacher/getActivityPage', // 活动数据分页
    Spatial: '/space/spaVisitor/userSpaceSearch/', // 空间搜索
    guestList: '/space/spaVisitor/getRecentVisitor/', // 获取最近访客列表
    interview: '/space/spaVisitor/addVisitorLog/', // 增加一次访问记录
    setBackground: '/space/spaVisitor/settingBackgroundImage/', // 设置背景图
    background: '/space/spaVisitor/getBackgroundImages', // 获取背景图列表
    scopeOfDisplay: '/space/spaVisitor/settingRadius/', // 设置展示范围
    casual: '/space/spaVisitor/pokeAround', // 随便逛逛
    notePaging: '/space/spaVisitor/getNoteInfo/', // 笔记分页
    giveLike: '/space/spaVisitor/giveLike/', // 点赞
    cardInfo: '/group/member/cardInfo/', // 个人名片
    setActivityShowAndHide: '/activity/space/showAndHide', //设置公开和隐藏（活动）
    setCourseShowAndHide: '/course/warehouse/space/showAndHide', //设置公开和隐藏（学程）
    setPhotoShowAndHide: '/photo/photo/space/showAndHide', //设置公开和隐藏（相册）
  },
  indexJiao: {
    /** 互动数据*/
    getSchoolList: '/admin/deptMember/getSchoolByTeacherId', // 根据机构id获取机构下的学校
    getDictItem: '/dict/dictItem/getDictItem/', // 获取字典项列表
    getList: '/mylesson/v2/statistics/list', // 互动课堂统计分析数据列表
    /** 课堂展示*/
    getWeekLesson: '/mylesson/lesson/v1/weekLesson', //获取查询条件
    getMonthLesson: '/mylesson/lesson/v1/monthLesson', //查询当前用户本月课堂报告
    getTeamWorkByLessonId: '/mylesson/lesson/v1/getTeamWorkByLessonId', //根据课堂ID获取小组提交作品数据
    /** 参与数据*/
    teacherGetClass: '/dataReport/teacher/dateReport/getClass', // 班级下拉框
    teacherGetCycles: '/dataReport/teacher/dateReport/getCycles', // 时间周期-教师
    teacherGroupDataSheetExport: '/dataReport/teacher/dateReport/groupDataSheetExport', // 教师导出
    teacherGetGroup: '/dataReport/teacher/dateReport/getGroup', // 小组下拉框
    teacherGetStudent: '/dataReport/teacher/dateReport/getStudent', // 学生下拉框
    groupDataSheet: '/dataReport/teacher/dateReport/groupDataSheet', // 小组及成员详细数据表
    interactionAndParticipation: '/dataReport/teacher/dateReport/interactionAndParticipation', // 互动与参与
  },
  indexGuan: {
    /** 课堂报告*/
    getLessonList: '/mylesson/report/v1/getLessonList', // 查询课堂报告列表
    dataReport: {
      rectorOverview: '/dataReport/rector/dateReport/overview', // 总体概览

      rectorGetWeekStatic: '/dataReport/rector/dateReport/getWeekStatic', // 本周课堂
      rectorGradeClassroomWeekStatic: '/dataReport/rector/dateReport/gradeClassroomWeekStatic', // 年级课堂组织情况
      rectorPerCycle: '/dataReport/rector/dateReport/perCycle', // 校长对比分析-按周期
      rectorBySubject: '/dataReport/rector/dateReport/bySubject', // 校长对比分析-按学科
      rectorByGrade: '/dataReport/rector/dateReport/byGrade', // 校长对比分析-年级
      rectorDataSheet: '/dataReport/rector/dateReport/dataSheet', // 教师授课详情
      rectorGetCycles: '/dataReport/rector/dateReport/getCycles/', // 时间周期
      rectorGetGrades: '/dataReport/rector/dateReport/getGrades', // 年级下拉框-校长
      rectorGetDisciplines: '/dataReport/rector/dateReport/getDisciplines', // 学科下拉框-校长

      directorGetWeekStatic: '/dataReport/director/dateReport/getWeekStatic', // 年级主任本周课堂
      directorGradeClassroomWeekStatic: '/dataReport/director/dateReport/gradeClassroomWeekStatic', // 年级课堂组织情况
      directorOverview: '/dataReport/director/dateReport/overview', // 年级主任总体概览
      directorPeriodLessons: '/dataReport/director/dateReport/periodLessons', // 周趋势，各学段，授课次数
      directorTeacherLessons: '/dataReport/director/dateReport/teacherLessons', // 周趋势，各教师，授课次数详情
      directorClassLessons: '/dataReport/director/dateReport/classLessons', // 周趋势，各班级，授课次数详情
      directorDataSheet: '/dataReport/director/dateReport/dataSheet',
      directorGetCycles: '/dataReport/director/dateReport/getCycles/', // 时间周期-主任
      directorGetGrades: '/dataReport/director/dateReport/getGrades', // 年级下拉框-主任
      directorGetDisciplines: '/dataReport/director/dateReport/getDisciplines', // 学科下拉框-主任

      getMonthStatic: '/dataReport/teacher/dateReport/getMonthStatic', // 本月课堂
      submissionDataStatistics: '/dataReport/teacher/dateReport/submissionDataStatistics', // 本月课堂作品提交数据统计
      teacherOverview: '/dataReport/teacher/dateReport/overview', // 总体概览
      participationRate: '/dataReport/teacher/dateReport/participationRate', // 参与展示率
      teacherLessons: '/dataReport/teacher/dateReport/teacherLessons', // 获赞数-课堂成果提交数
      interactionAndParticipation: '/dataReport/teacher/dateReport/interactionAndParticipation', // 互动与参与
      learningAndQuality: '/dataReport/teacher/dateReport/learningAndQuality', // 学习成果与质量
      pushResourceRate: '/dataReport/teacher/dateReport/pushResourceRate', // 推送资源利用率
      downloadRate: '/dataReport/teacher/dateReport/downloadRate', // 下载资源利用率
      groupDataSheet: '/dataReport/teacher/dateReport/groupDataSheet', // 小组及成员详细数据表`
      teacherGetCycles: '/dataReport/teacher/dateReport/getCycles', // 时间周期-教师
      teacherGetClass: '/dataReport/teacher/dateReport/getClass', // 班级下拉框
      teacherGetGroup: '/dataReport/teacher/dateReport/getGroup', // 小组下拉框
      teacherGetStudent: '/dataReport/teacher/dateReport/getStudent', // 学生下拉框
      learningAndQualitySelect: '/dataReport/teacher/dateReport/learningAndQualitySelect', // 学生对比下拉数据

      rectorDataSheetExport: '/dataReport/rector/dateReport/dataSheetExport', // 导出校长数据
      directorDataSheetExport: '/dataReport/director/dateReport/dataSheetExport', // 年级主任导出数据
      teacherGroupDataSheetExport: '/dataReport/teacher/dateReport/groupDataSheetExport', // 教师导出

      school: '/admin/dataAuth/getAuthSchoolList', // 获取用户的学校信息
      schoolOrGrade: '/admin/dataAuth/getDeptAuthList', // 获取用户授权得学校或年级
      dataView: '/admin/app/access/alias/dataView', // 获取数据看板用户数据权限
    },
  },
  indexBei: {
    /* 学程设计 */
    getCourseList: '/course/warehouse/page/create', // 获取学程列表
    getCourseTree: '/course/course/item/tree/catalog/', // 获取学程目录树,
    saveCourse: '/course/newCourse/save', // 新建学程
    getUserSubject: '/admin/member/getSubject/', //获取用户任教信息
    curriculumSetCreate: '/course/warehouse/setCreate/', // 学程继续编辑
    curriculumCite: '/course/warehouse/cite/', // 学程引用
    getGroupPubInfo: '/group/new/dict/prepare/', // 获取群组发布信息
    getCoursePubGroups: '/course/course/pub/list/', // 获取学程已发布群组
    pubCourse: '/course/course/pub/pub', // 学程发布
    courseIsCatelogFully: '/course/warehouse/regCatalog/', // 校验学程目录是否完整
    getExercisePage: '/exercise/personal/creating/page', // 获取习题列表
    getExercisesPaperPage: '/exercise/createCentre/exercisesPaper/getExercisesPaperPage', // 习练列表
    practicePaperCite: '/exercise/createCentre/exercisesPaper/reference/', // 引用习练
    groupInformation: '/exercise/exercisesPaperPub/', //获取指定习练发布的群组信息
    getPubGroupList: '/exercise/exercisesPaperPub/getPubGroupList/', // 获取群组发布信息-习练
    exercisesPaperPub: '/exercise/exercisesPaperPub', // 发布习练
    /* 资源搜索 */
    collectResource: '/resource/resource/collection', // 资源收藏/取消收藏
    collectCourse: '/course/course/coll/', // 学程收藏
    copyResource: '/resource/institution/cite/', // 资源引用至创作中心
    copyCourse: '/course/warehouse/copyAndCite/', // 学程引用
    getRecommendList: '/resource/common/institutionRecommend', //教师工作台->获取推荐资源列表
  },
  indexBeiDiscuss: {
    getActivityAuth: '/admin/app/access/alias/activity', // 获取是否有活动应用权限
    activeDiscussTask: '/activity/discussParticipant/activeDiscussTask/', // 查询当前用户正在参与的研讨活动
    /* 研训活动 */
    getIsInDiscuss: '/activity/participant/exist/', // 判断用户是否在研训中
    operationRecord: '/activity/operationRecord', // 记录研训操作
    getDiscussBasic: '/activity/discuss/basic/', // 研训基本信息
    getDiscussUsers: '/activity/participant/discussPerson/', // 获取教研所有角色
    addNotice: '/activity/discussAnnouncement/add', // 添加公告
    getNoticeList: '/activity/discussAnnouncement/list/', // 公告列表
    getRecentNotice: '/activity/discussAnnouncement/getFirst/', // 获取最近一个公告
    deleteNotice: '/activity/discussAnnouncement/delete/', // 删除公告
    addResource: '/activity/discussResource/add', // 添加资料
    getResourceList: '/activity/discussResource/list/', // 资料列表
    deleteResource: '/activity/discussResource/delete/', // 删除资料
    getContactCourse: '/course/warehouse/page/create', // 获取关联学程列表
    courseCopy: '/course/warehouse/copy', // 复制学程
    getLessonList: '/activity/onlineCourse/', // 课程列表
    saveLessonVideoProgress: '/activity/progress', // 保存课程视频观看进度
    addLessonCatalog: '/activity/onlineCourse/catalog', // 添加课程目录
    editLessonTitle: '/activity/onlineCourse', // 更改课程目录、视频标题
    deleteLesson: '/activity/onlineCourse/', // 删除课程目录、视频
    addLessonVideo: '/activity/onlineCourse', // 上传课程视频
    dragLessonVideo: '/activity/onlineCourse/drag', // 拖拽课程视频顺序
    getMeetingList: '/activity/conference/', // 获取会议/直播列表
    delMeeting: '/activity/conference/', // 删除会议/直播
    checkMeetingUrl: '/general/resource/chechValid', // 校验会议地址
    addMeeting: '/activity/conference', // 添加会议/直播
    getResultList: '/activity/achievement/', // 成果列表
    addResult: '/activity/achievement', // 上传成果
    delResult: '/activity/achievement/', // 删除成果
    getCanvasDrawId: '/activity/documentResearch/pointId', // 生成画布元素唯一ID
    getBoard: '/activity/whiteBoard/', // 获取白板数据
    addEditBoard: '/activity/whiteBoard', // 新增/保存白板数据
    delBoard: '/activity/whiteBoard/', // 删除白板
    getResearchFile: '/activity/documentResearch/list/', // 文件研究-获取文件列表
    delResearchFile: '/activity/documentResearch/', // 文件研究-删除文件
    addResearchFile: '/activity/documentResearch', // 文件研究-上传文件
    getFileCanvas: '/activity/documentDraw/', // 文件研究-获取画布对象
    addEditFileDraw: '/activity/documentDraw', // 文件研究-添加/编辑画布元素
    removeFileDraw: '/activity/documentDraw/', // 文件研究-删除画布元素
    addFileAnnocation: '/activity/annocation', // 文件研究-添加批注
    delFileAnnocation: '/activity/annocation/', // 文件研究-删除批注
    getFileAnnocation: '/activity/annocation/', // 文件研究-获取批注列表
    delFileAnnocationList: '/activity/annocation/all/', // 文件研究-删除批注列表
    addCourseAnnocation: '/activity/courseAnnocation', // 学程研究-添加批注
    delCourseAnnocation: '/activity/courseAnnocation/', // 学程研究-删除批注
    getCourseAnnocation: '/activity/courseAnnocation/', // 学程研究-获取批注列表
    delCourseAnnocationList: '/activity/courseAnnocation/all/', // 学程研究-删除批注列表
    demoCourseDetail: '/course/newCourse/showDetail/', // 演示模式学程详情
    getCourseResearch: '/activity/courseResearch/list/', // 学程研究-学程列表
    delResearchCourse: '/activity/courseResearch/', // 学程研究-删除学程
    addResearchCourse: '/activity/courseResearch', // 学程研究-添加学程
    getCourseCanvas: '/activity/courseDraw/', // 学程研究-获取画布对象
    addEditCourseDraw: '/activity/courseDraw', // 学程研究-添加/编辑画布元素
    removeCourseDraw: '/activity/courseDraw/', // 学程研究-删除画布元素
    getDictItem: '/dict/dictItem/getDictItem/', // 获取学段、学科等字典
    getTutorial: '/dict/tutorial/list', // 获取教材
    getUnit: '/dict/tutorialDir/getDirByTutorial/', // 获取单元
    copyCourse: '/course/warehouse/copy', // 复制学程
    editCourse: '/course/newCourse/save', // 修改学程属性
  },
  indexGai: {
    repeal: '/exercise/exercisesPaperPub/', //撤销
    paperPub: '/exercise/exercisesPaperPub/', //习练详情
    prepareList: '/exercise/personalExercisesPaper/prepareList/', //习练列表
    exercisesPaperPub: '/exercise/exercisesPaperPub', // 发布习练
    getCourseList: '/course/warehouse/page/create', // 获取学程列表(新接口)
    getCourseDetails: '/course/course/local/details/', // 学程发布详情
    getCourseRevoke: '/course/course/pub/cancelPub/', // 撤销发布
    markedInfo: '/course/newCourse/markedInfo/', // 查询学程批阅信息
  },
  /**
   * 验收报告
   */
  report: {
    getPadOptionCycle: '/evaluate/statistics/option/padOptionCycle', // 获取时间周期
    permissionCheck: 'evaluate/evaProjectPermissionCheck/prePermissionCheck', // 应用前置检查
    userInfo: 'evaluate/execute/userInfo', // 获取用户名称和头像等信息
    acceptInfo: '/evaluate/execute/acceptInfo', // 个人验收报告【个人信息】
    getProjectList: '/evaluate/evaProjectPermissionCheck/classDeptListByUserId', // 查询可选择的班级
    acceptReport: '/evaluate/execute/acceptReport', // 验收报告【达标验收】
    evaluateSubmit: '/evaluate/execute/submit', // 提交验收
    acceptView: '/evaluate/execute/acceptView', // 验收详情列表
    deleteExecute: '/evaluate/execute/delete/', // 删除评价
    acceptOverview: '/evaluate/execute/acceptOverview', // 验收总览
    switchClasses: 'evaluate/evaProjectPermissionCheck/switchClasses', // 设置班级
  },
  /**
   * 班级管理-分组管理
   */
  groupManage: {
    getAllOptions: '/admin/dept/getClassList/', // 获取班级类型、班级、学科下拉
    getNoTeamStudentList: '/classmanage/classGroup/v1/getNoGroupStudentList', // 查询班级未分组学生信息
    getTeamStudentLists: '/classmanage/classGroup/v1/getLists', // 查询班级分组信息
    addGroup: '/classmanage/classGroup/v1/addGroup', // 添加分组信息
    delGroup: '/classmanage/classGroup/v1/delGroup/', // 删除分组
    updGroup: '/classmanage/classGroup/v1/updGroup', // 修改分组
    updGroupSort: '/classmanage/classGroup/v1/updGroupSort', // 修改分组排序
    addStudent: '/classmanage/classGroupUser/v1/addStudent', // 分组添加学生
    delStudent: '/classmanage/classGroupUser/v1/delStudent', // 移除学生信息
    setHeadman: '/classmanage/classGroupUser/v1/setHeadman', // 设置小组长
    setSubjectMonitor: '/classmanage/subjectMonitor/v1/setSubjectMonitor', // 设置学科班长
    cancelSubjectMonitor: '/classmanage/subjectMonitor/v1/cancelSubjectMonitor', // 取消学科班长
  },
  // 学生空间
  spaceInfo: {
    getUserSpaceBaseInfo: '/space/spaVisitor/getSpaceBaseInfo/', // 获取用户空间基本信息
    settingRadius: '/space/spaVisitor/settingRadius/', // 设置展示范围
    getBackgroundImages: '/space/spaVisitor/getBackgroundImages', // 获取背景图列表
    settingBackgroundImage: '/space/spaVisitor/settingBackgroundImage/', // 设置背景图
    userSpaceSearch: '/space/spaVisitor/userSpaceSearch/', // 空间搜索
    getRecentVisitor: '/space/spaVisitor/getRecentVisitor/', // 获取最近访客列表
    getCardInfo: '/group/member/cardInfo/', // 获取用户名片信息
    addVisitorLog: '/space/spaVisitor/addVisitorLog/', // 增加一次访问记录
    pokeAround: '/space/spaVisitor/pokeAround', // 随便逛逛，随机获取一个本机构有内容的userId
    getClassShow: '/space/spaVisitor/getClassroomShowInfo/', //课堂展示信息分页
    getNote: '/space/spaVisitor/getNoteInfo/', //笔记分页
    getShowDetail: '/space/spaVisitor/getUserSpaceShowDetail/', //课堂展示细节
  },
  // 学生空间-活动
  spaceActivity: {
    giveALike: '/space/spaVisitor/giveLike/', // 点赞
    getActivityList: '/space/spaVisitor/studentSpace/workPage', // 获取活动列
    getWorkPageDetails: '/space/spaVisitor/studentSpace/workPageDetails/', // 活动作品详情
    setStuActivity: '/activity/work/space/showAndHide', //设置公开和隐藏（学生活动）
  },
}
